export function getCartTotal({ cart, checkout, cartProducts }) {
    let installTotal = 0;

    const cartSubTotal = cart.items.reduce((total, item) => {
        const productIndex = cartProducts.findIndex((product => product.ean === item.ean));
        if (productIndex !== -1) {
            const product = cartProducts[productIndex];
            return total + product.price * item.quantity;
        }
        return 0;
    }, 0);

    if (checkout.sip === 'install' && checkout.selectedShop) {
        const shop = checkout.shops.find(o => o.id === checkout.selectedShop);
        const price = shop.price;
        installTotal = cart.items.reduce((total, item) => {
            const tiresInItem = item.isSet ? (item.isAtvSet ? 4 : 2) : 1;
            return total + price * tiresInItem;
        }, 0);
    }

    return {
        cartSubTotal,
        installTotal,
        grandTotal: cartSubTotal - (checkout.appliedDiscount || 0)
    };
}